import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAccountsManagers} from 'src/openapi/admin/apis/AccountManagerRelationsApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    accountSearchResultPrimaryManagerActions,
    accountSearchResultPrimaryManagerDataSelector,
    accountSearchResultPrimaryManagerResultSelector,
} from '../slices/account-search-result-primary-manager.slice';
import {accountSearchResultStateSelector} from '../slices/account-search-result-state.slice';

import type {AccountSearchResultCacheKeys} from '../typedef';
import type {AccountPrimaryManager} from 'src/openapi/admin/models/AccountPrimaryManager';


type Props = {
    accountIds: number[],
    totalCount: number,
};

export const useGetAccountSearchResultPrimaryManager = ({accountIds, totalCount}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback(() => apiDispatch(getAccountsManagers({
        requestBody: [...new Set(accountIds)],
    })), [accountIds, apiDispatch]);

    const setLoadedData = useCallback((
        response: Record<string, AccountPrimaryManager>,
        dataCacheKeys: AccountSearchResultCacheKeys,
    ) => {
        dispatch(accountSearchResultPrimaryManagerActions.onSuccess(({
            cacheKeys: dataCacheKeys,
            totalCount,
            data: response,
        })));
    }, [totalCount, dispatch]);

    return useCachedTable({
        dataSelector: accountSearchResultPrimaryManagerDataSelector,
        stateSelector: accountSearchResultStateSelector,
        resultSelector: accountSearchResultPrimaryManagerResultSelector,
        actions: accountSearchResultPrimaryManagerActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: false,
    });
};
